import { useRef, useState } from "react";

const CompanyAppAccessReadOnlyRow = ({ key, t, appAccessItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [editFlag, setEditFlag] = useState(false);
	const [subscriptionDate, setSubscriptionDate] = useState(appAccessItem.subscriptionDate);
	const today = new Date().toISOString().split("T")[0];
	const subscriptionDateRef = useRef(null);
	const [isSubmit, setIsSubmit] = useState(false);

	const onEdit = () => {
		if (add) {
			setError(t("error.newRowAdded"));
		} else {
			setEditFlag(true);
		}
	}

	function subscriptionDateHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedSubscriptionDate = e.target.value;
		setSubscriptionDate(selectedSubscriptionDate);
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		setSubscriptionDate(subscriptionDateRef.current.value);
		let initialValues = {
			appName: appAccessItem.appName,
			subscriptionDate: subscriptionDateRef.current.value
		};

		if (!appAccessItem.appName) {
			setError(t("error.appName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(2, initialValues, submitComplete);
		}

	}

	function submitDelete(event, appAccessItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, appAccessItem, submitComplete);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{appAccessItem.appDisplayName}</td>
			{editFlag ?
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input
							type="date"
							name="subscriptionDate"
							id="subscriptionDate"
							value={subscriptionDate || today}
							className="form-control rounded-pill shadow-sm px-4 "
							ref={subscriptionDateRef}
							onChange={(e) => (subscriptionDateHandler(e))}
							style={{ maxWidth: "250px" }}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.status}</td>
					<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
						<div id="submit-spinner"
							className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
						>
						</div>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (setEditFlag(false))}>{t("page.cancel")}</button>
					</td>
				</>
				:
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.subscriptionDate}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{appAccessItem.status}</td>
					<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"}
							onClick={(event) => onEdit(event)}>{t("page.edit")}</button>
						<div id="submit-spinner"
							className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
						>
						</div>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, appAccessItem)}>
							{appAccessItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</td>
				</>
			}

		</tr>
	)
}
export default CompanyAppAccessReadOnlyRow;